import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../images/avatar';
import Text from '../typography/v2/text';
import { HStack, VStack } from '../layouts/stack.layout';
import { channels } from '../../test.data';
import { TinyUser } from '../../types/userProfile';

type MembersQuery = 'ONLINE' | 'OFFLINE';

type Props = {
  query: MembersQuery;
  params: {
    id?: string;
    maxCount?: number;
  };
};

export default function MembersList({ query, params }: Props) {
  const members = GET[query](params.id, params.maxCount);

  return (
    <VStack gap="sm" extensions="w-full px-5">
      {members.map((member: TinyUser & { online: boolean }) => (
        <MemberItem {...member} />
      ))}
    </VStack>
  );
}

type MemberItemProps = {
  username: string;
  avatarUrl: string;
  online?: boolean;
};

function MemberItem({ username, avatarUrl, online }: MemberItemProps) {
  return (
    <Link to={`/${username}`}>
      <HStack gap="sm" extensions="w-full items-center py-2">
        <Avatar size="2xs" url={avatarUrl} alt={username} />
        <VStack gap="xs">
          <Text>{username}</Text>
          {online ? (
            <HStack gap="xs" extensions="items-center">
              <div className="rounded-full bg-green-500 h-1.5 w-1.5" />
              <Text variant="supplementary">Online</Text>
            </HStack>
          ) : (
            <HStack gap="xs" extensions="items-center">
              <div className="rounded-full bg-orange-500 h-1.5 w-1.5" />
              <Text variant="supplementary">Offline</Text>
            </HStack>
          )}
        </VStack>
      </HStack>
    </Link>
  );
}

type MembersQueryMap = { [key in MembersQuery]: Function };

const GET: MembersQueryMap = {
  ONLINE: (id: string, maxCount: number) => {
    const data = channels.find((c) => c.id === id)?.listeners;
    console.log({ maxCount });
    if (maxCount) {
      return data?.slice(0, 5).map((data) => ({ ...data, online: true }));
    }
    return data?.map((data) => ({ ...data, online: true }));
  },
  OFFLINE: (id: string, maxCount: number) => {
    const data = channels.find((c) => c.id === id)?.listeners;
    return data?.map((data) => ({ ...data, online: false }));
  },
};
